/* tslint:disable */
/* eslint-disable */
/**
 * AICare API Chat
 * CRUD Chat
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ChatDto
 */
export interface ChatDto {
    /**
     * 
     * @type {number}
     * @memberof ChatDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ChatDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatDto
     */
    'title': string;
    /**
     * 
     * @type {Array<ChatMessageDto>}
     * @memberof ChatDto
     */
    'messages': Array<ChatMessageDto>;
}
/**
 * 
 * @export
 * @interface ChatMessageDto
 */
export interface ChatMessageDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    'chatId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    'typeUser': ChatMessageDtoTypeUserEnum;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDto
     */
    'userId': string;
    /**
     * 
     * @type {Array<ChatMessageResourceDto>}
     * @memberof ChatMessageDto
     */
    'resources'?: Array<ChatMessageResourceDto>;
}

export const ChatMessageDtoTypeUserEnum = {
    User: 'USER',
    Chatbot: 'CHATBOT'
} as const;

export type ChatMessageDtoTypeUserEnum = typeof ChatMessageDtoTypeUserEnum[keyof typeof ChatMessageDtoTypeUserEnum];

/**
 * 
 * @export
 * @interface ChatMessageResourceDto
 */
export interface ChatMessageResourceDto {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageResourceDto
     */
    'document_name': string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageResourceDto
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface CreateChatDto
 */
export interface CreateChatDto {
    /**
     * 
     * @type {string}
     * @memberof CreateChatDto
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface CreateChatMessageDto
 */
export interface CreateChatMessageDto {
    /**
     * 
     * @type {string}
     * @memberof CreateChatMessageDto
     */
    'chatId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateChatMessageDto
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof CreateChatMessageDto
     */
    'typeUser': CreateChatMessageDtoTypeUserEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateChatMessageDto
     */
    'userId': string;
}

export const CreateChatMessageDtoTypeUserEnum = {
    User: 'USER',
    Chatbot: 'CHATBOT'
} as const;

export type CreateChatMessageDtoTypeUserEnum = typeof CreateChatMessageDtoTypeUserEnum[keyof typeof CreateChatMessageDtoTypeUserEnum];

/**
 * 
 * @export
 * @interface DeleteBulkStringDto
 */
export interface DeleteBulkStringDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteBulkStringDto
     */
    'ids': Array<string>;
}

/**
 * ChatApi - axios parameter creator
 * @export
 */
export const ChatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create new Chat
         * @summary Create new Chat
         * @param {CreateChatDto} createChatDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerCreate: async (createChatDto: CreateChatDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createChatDto' is not null or undefined
            assertParamExists('chatControllerCreate', 'createChatDto', createChatDto)
            const localVarPath = `/api/v1/chat/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChatDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * New message created
         * @summary New message created
         * @param {CreateChatMessageDto} createChatMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerCreateMessage: async (createChatMessageDto: CreateChatMessageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createChatMessageDto' is not null or undefined
            assertParamExists('chatControllerCreateMessage', 'createChatMessageDto', createChatMessageDto)
            const localVarPath = `/api/v1/chat/message/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChatMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete many Chats
         * @summary Delete many Chats
         * @param {DeleteBulkStringDto} deleteBulkStringDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerDelete: async (deleteBulkStringDto: DeleteBulkStringDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteBulkStringDto' is not null or undefined
            assertParamExists('chatControllerDelete', 'deleteBulkStringDto', deleteBulkStringDto)
            const localVarPath = `/api/v1/chat/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteBulkStringDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get chats  by userId
         * @summary Get chats by userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerFindByUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all messages in a chat
         * @summary Get all messages in a chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerFindMessageByChat: async (chatId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('chatControllerFindMessageByChat', 'chatId', chatId)
            const localVarPath = `/api/v1/chat/message/{chatId}`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatApi - functional programming interface
 * @export
 */
export const ChatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatApiAxiosParamCreator(configuration)
    return {
        /**
         * Create new Chat
         * @summary Create new Chat
         * @param {CreateChatDto} createChatDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatControllerCreate(createChatDto: CreateChatDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatControllerCreate(createChatDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.chatControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * New message created
         * @summary New message created
         * @param {CreateChatMessageDto} createChatMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatControllerCreateMessage(createChatMessageDto: CreateChatMessageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatControllerCreateMessage(createChatMessageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.chatControllerCreateMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete many Chats
         * @summary Delete many Chats
         * @param {DeleteBulkStringDto} deleteBulkStringDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatControllerDelete(deleteBulkStringDto: DeleteBulkStringDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatControllerDelete(deleteBulkStringDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.chatControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get chats  by userId
         * @summary Get chats by userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatControllerFindByUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatControllerFindByUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.chatControllerFindByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all messages in a chat
         * @summary Get all messages in a chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatControllerFindMessageByChat(chatId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatControllerFindMessageByChat(chatId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatApi.chatControllerFindMessageByChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatApi - factory interface
 * @export
 */
export const ChatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatApiFp(configuration)
    return {
        /**
         * Create new Chat
         * @summary Create new Chat
         * @param {CreateChatDto} createChatDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerCreate(createChatDto: CreateChatDto, options?: any): AxiosPromise<ChatDto> {
            return localVarFp.chatControllerCreate(createChatDto, options).then((request) => request(axios, basePath));
        },
        /**
         * New message created
         * @summary New message created
         * @param {CreateChatMessageDto} createChatMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerCreateMessage(createChatMessageDto: CreateChatMessageDto, options?: any): AxiosPromise<ChatMessageDto> {
            return localVarFp.chatControllerCreateMessage(createChatMessageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete many Chats
         * @summary Delete many Chats
         * @param {DeleteBulkStringDto} deleteBulkStringDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerDelete(deleteBulkStringDto: DeleteBulkStringDto, options?: any): AxiosPromise<void> {
            return localVarFp.chatControllerDelete(deleteBulkStringDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Get chats  by userId
         * @summary Get chats by userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerFindByUser(options?: any): AxiosPromise<ChatDto> {
            return localVarFp.chatControllerFindByUser(options).then((request) => request(axios, basePath));
        },
        /**
         * Get all messages in a chat
         * @summary Get all messages in a chat
         * @param {string} chatId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerFindMessageByChat(chatId: string, options?: any): AxiosPromise<ChatMessageDto> {
            return localVarFp.chatControllerFindMessageByChat(chatId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChatApi - object-oriented interface
 * @export
 * @class ChatApi
 * @extends {BaseAPI}
 */
export class ChatApi extends BaseAPI {
    /**
     * Create new Chat
     * @summary Create new Chat
     * @param {CreateChatDto} createChatDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatControllerCreate(createChatDto: CreateChatDto, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatControllerCreate(createChatDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * New message created
     * @summary New message created
     * @param {CreateChatMessageDto} createChatMessageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatControllerCreateMessage(createChatMessageDto: CreateChatMessageDto, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatControllerCreateMessage(createChatMessageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete many Chats
     * @summary Delete many Chats
     * @param {DeleteBulkStringDto} deleteBulkStringDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatControllerDelete(deleteBulkStringDto: DeleteBulkStringDto, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatControllerDelete(deleteBulkStringDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get chats  by userId
     * @summary Get chats by userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatControllerFindByUser(options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatControllerFindByUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all messages in a chat
     * @summary Get all messages in a chat
     * @param {string} chatId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApi
     */
    public chatControllerFindMessageByChat(chatId: string, options?: RawAxiosRequestConfig) {
        return ChatApiFp(this.configuration).chatControllerFindMessageByChat(chatId, options).then((request) => request(this.axios, this.basePath));
    }
}



